import {Button, Dialog, Grid, LinearProgress, makeStyles, Paper, Typography} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import React from "react";
import {breakpoints, reviewStyle, StyledDivider} from "../../../../UIComponent/CommonStyle";
import customAxios from "../../../../API/customAxios";

const useStyles = makeStyles((theme) => ({
    ...reviewStyle(theme),
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 2, 1),
        [breakpoints.up("md")]: {
            padding: theme.spacing(2, 4, 3),
        }
    },
}));

export default function MultiUpdateReviewDialog(
    {
        open,
        onClose,
        updateAction,
        selectedEmployeeIDs,
        approverID,
        selectedEmployeeNames,
        selectedApproverName,
        updateApproverTable
    }) {
    const classes = useStyles();
    const [showAfterSubmittion, setShowAfterSubmittion] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [isLoading, setisLoading] = React.useState(false);

    const handleClose = () => {
        if (!isLoading) {
            onClose();
        }
    };

    const submitAction = () => {
        setisLoading(true);
        switch (updateAction) {
            case 'ChangeFirstApprover':
                putApprovers('first_approver', approverID);
                break;
            case 'ChangeSecondApprover':
                putApprovers('second_approver', approverID);
                break;
            case 'RemoveSecondApprover':
                removeSecondApprovers();
                break;
        }
    }

    const putApprovers = async (approverType, approverID) => {
        let requestBody = {};
        requestBody['employeeIDs'] = selectedEmployeeIDs;
        requestBody['updates'] = {};
        requestBody['updates'][approverType] = approverID;
        try {
            const putApproversResult = await customAxios.put(`/approvers`, requestBody);
            handleAPIResult(putApproversResult);
        } catch (e) {
            handleAPIResult(e);
        }
    }

    const removeSecondApprovers = async () => {
        try {
            const removeSecondApproversResult = await customAxios.post(`/approvers/removeSecondApprovers/`,
                {'employeeIDs': selectedEmployeeIDs}
            )
            handleAPIResult(removeSecondApproversResult);
        } catch (e) {
            handleAPIResult(e);
        }
    }

    function handleAPIResult(res) {
        if (res.status === 201) {
            updateApproverTable();
        }
        setisLoading(false);
        setIsError(res.status !== 201);
        setShowAfterSubmittion(true);
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            {isLoading && <LinearProgress/>}
            {!showAfterSubmittion ?
                <Paper className={classes.modalPaper} style={{width: 600, wordWrap: 'break-word'}}>
                    <Typography variant="h6" color="primary" className={classes.title}>
                        Multi Edit Summary
                    </Typography>
                    <StyledDivider/>
                    <Grid container spacing={2}>
                        <Grid item xs={12}><Typography className={classes.subtitle}>Please confirm the below
                            information</Typography></Grid>
                        <Grid item xs={4}><Typography className={classes.subtitle}>Affected
                            Employees:</Typography></Grid>
                        <Grid item xs={8}><Typography className={classes.subtitle}>{selectedEmployeeNames?.[0] ?
                            selectedEmployeeNames.reduce((previousValue, currentValue) => previousValue + ", " + currentValue) : []
                        }</Typography></Grid>
                        <Grid item xs={4}><Typography className={classes.subtitle}>Action:</Typography></Grid>
                        {updateAction === 'ChangeFirstApprover' ?
                            <Grid item xs={8}><Typography className={classes.subtitle}>Update 1st approver
                                → {selectedApproverName}</Typography></Grid> : null}
                        {updateAction === 'ChangeSecondApprover' ?
                            <Grid item xs={8}><Typography className={classes.subtitle}>Update 2nd approver
                                → {selectedApproverName}</Typography></Grid> : null}
                        {updateAction === 'RemoveSecondApprover' ?
                            <Grid item xs={8}><Typography className={classes.subtitle}>Remove 2nd approver</Typography></Grid> : null}
                        <Grid item xs={12}>
                            {updateAction === 'RemoveSecondApprover' ?
                                <Typography className={classes.subtitle}>* Pending application will proceed to HR for
                                    approval</Typography>
                                :
                                <Typography className={classes.subtitle}>* Pending application will transfer to new
                                    approver</Typography>
                            }
                        </Grid>
                        <div style={{position: 'absolute', right: '30px', bottom: '20px'}}>
                            <Button
                                type="submit" variant="contained" color="primary" disabled={isLoading}
                                onClick={submitAction} className={classes.submitButton}>
                                Confirm
                            </Button>
                            <Button type="submit" variant="contained" color="secondary" disabled={isLoading}
                                    onClick={handleClose} className={classes.submitButton}>
                                Cancel
                            </Button>
                        </div>
                    </Grid>
                </Paper>
                :
                <Paper className={classes.afterSubmitPage}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {!isError ? <Typography className={classes.title}>Edit Successful</Typography> :
                                <Typography className={classes.title}>An error occurred, please try again
                                    later.</Typography>}
                        </Grid>
                        <Grid item xs={12}>
                            {!isError ? <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/> :
                                <CancelIcon color="secondary" style={{fontSize: '100px'}}/>}
                        </Grid>
                    </Grid>
                </Paper>
            }
        </Dialog>
    );
}
